// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3KOjS","sendOtp":"AuthorizeToLogin_sendOtp__RJafz"};